import * as React from 'react';
export const morganchaseSvg = React.forwardRef(function morganchaseSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#107ACA',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M25.08 12.97c.41 0 .87.44.87.83l-.02 6.08-6.04 6.07V12.97h5.2zM18.2 25.95h-6.07l-6.08-6.06h12.98v5.2c0 .4-.44.86-.83.86zM12.97 6.92c0-.4.48-.87.87-.87h6.05l6.06 6.06H12.97V6.9zm-6.05 12.1c-.41 0-.87-.47-.87-.86v-6.05l6.06-6.06v12.98H6.9z',
      }),
    ),
  );
});
morganchaseSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var morganchase = {
  category: 'brand',
  colorable: false,
  name: 'morganchase',
  svg: morganchaseSvg,
};
